import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    token: state.token, // 这个就是存入localStorage的值 vuex存储在内存，localstorage则以文件的方式存储在本地 可以自动将 Vuex的 store 数据本地持久化存储
    userInfo: state.userInfo,
    tabbarFalg: state.tabbarFalg,
    addressInfo: state.addressInfo,
    vConsoleShow: state.vConsoleShow,
    currPageUrl:state.currPageUrl,
    goodsInfo:state.goodsInfo,
    submitNumber:state.submitNumber,
    liveItem:state.liveItem,
    payInfo:state.payInfo,
    cartIds: state.cartIds, // 购物车下单ids
    shopId: state.shopId, // 购物车下单shop id
    bonusInfo:state.bonusInfo,
    wxSignUrl: state.wxSignUrl, // 保存路由地址
    businessBabbar:state.businessBabbar,
    zhiBoToken: state.zhiBoToken,
    recruitScrollY:state.recruitScrollY,
    appTheme:state.appTheme
  })
})
export default new Vuex.Store({
  state: {
    vConsoleShow: false,  // vConsole显示
    terminalInfo: '',
    token: '',
    userInfo: '',
    tabbarFalg: false, // 是否显示 tabbar
    addressInfo: '',
    goodsInfo: '',
    submitNumber: '', // 详情页进入订单界面选择的数量
    payTypeId: '', // 一元秒杀id
    currPageUrl: '', // 为了处理token401 要保存路径
    liveItem: '', // 精品直播当前播放的视频
    payInfo: '', // 支付信息
    factoryItem: '', // 探厂当前项
    cartIds: '', // 购物车下单ids
    shopId: '',// 购物车下单shop id
    bonusInfo: '', // 优惠券信息
    wxSignUrl: '', // 保存路由地址
    businessBabbar: false,// 运营中心是否显示 tabbar
    zhiBoToken:'', // 直播间token
    recruitScrollY:0, // 记录首页滑动位置
    appTheme: 'dengyun' // 主题
  },
  mutations: { // 全局同步方法, 调用方法,this.$store.commit("xxx")
    // 专用于修改state中的数据，通过commit触发
    // setTerminalInfo (state, terminalInfo) {
    //   state.terminalInfo = terminalInfo
    //   localStorage.terminalInfo = terminalInfo // 同步存储token至localStorage
    // },
    changeRecruitScrollY(state,recruitScrollY) {
      state.recruitScrollY = recruitScrollY
    },
    setUserInfo(state, info){
      state.userInfo = info;
      localStorage.userInfo = info;
    },
    setToken(state, token) {
      state.token = token;
      localStorage.token = token // 同步存储token至localStorage
      console.log(token)
    },
    setZhiBoToken(state, token) {
      state.zhiBoToken = token;
      localStorage.zhiBoToken = token // 同步存储token至localStorage
      console.log(token)
    },
    setAppTheme(state,theme){
      state.appTheme = theme
    },
    setTabbarShow(state,tabbarFalg){
      state.tabbarFalg = tabbarFalg
    },
    setAddressInfo(state,info){
      state.addressInfo = info
      localStorage.addressInfo = info;
    },
    setGoodsInfo(state,info){
      state.goodsInfo = info
      localStorage.goodsInfo = info;
    },
    setPayInfo(state,info){
      state.payInfo = info
      localStorage.payInfo = info;
    },
    setSubmitNumber(state,num){
      state.submitNumber = num
      localStorage.submitNumber = num;
    },
    setPayTypeId(state,id){ // 1元购项目id
      state.payTypeId = id
    },
    setVconsole (state) {
      state.vConsoleShow = true
    },
    setCurrPageUrl(state, pageUrl){
      state.currPageUrl = pageUrl
    },
    setLiveItem(state, item){
      state.liveItem = item
    },
    setFactoryItem(state,item){
      state.factoryItem= item
    },
    setCartIds(state,item){
      state.cartIds= item
    },
    setShopId(state,item){
      state.shopId= item
    },
    setBonusInfo(state,item){
      state.bonusInfo = item
    },
    setWechatSignUrl(state, wxSignUrl) {
      // 关键点
      // IOS仅记录第一次进入页面时的URL
      // IOS微信切换路由实际URL不变，只能使用第一进入页面的URL进行签名
      state.wxSignUrl = wxSignUrl;
    }
  },
  getter: { // Vuex属性计算,在视图里面当变量使用
    // Vuex中的计算属性，相当于vue中的computed,依赖于state状态值，
    // 状态值一旦改变，getter会重新计算，也就是说，
    // 当一个数据依赖于另一个数据发生变化时，就要使用getter
    // 判断是否有token,如果没有重新赋值，返回给state的token
    getToken (state) {
      if (!state.token) {
        state.token = localStorage.getItem('token')
      }
      return state.token
    },
    getZhiBoToken (state) {
      if (!state.token) {
        state.zhiBoToken = localStorage.getItem('zhiBoToken')
      }
      return state.token
    },
    recruitScrollY(state){
      return state.recruitScrollY
    },
    getUserInfo (state) {
      if (!state.userInfo) {
        state.userInfo = localStorage.getItem('userInfo')
      }
      return state.userInfo
    },
    getGoodsInfo () {
      if (!state.goodsInfo) {
        state.goodsInfo = localStorage.getItem('goodsInfo')
      }
      return state.goodsInfo
    },
    getPayInfo () {
      if (!state.payInfo) {
        state.payInfo = localStorage.getItem('payInfo')
      }
      return state.payInfo
    },
    getSubmitNumber () {
      if (!state.submitNumber) {
        state.submitNumber = localStorage.getItem('submitNumber')
      }
      return state.submitNumber
    },
    getAddressInfo (state) {
      if (!state.addressInfo) {
        state.addressInfo = localStorage.getItem('addressInfo')
      }
      return state.addressInfo
    },
    getLiveItem (state){
      if (!state.liveItem) {
        state.liveItem = localStorage.getItem('liveItem')
      }
      return state.liveItem
    },
    getCartIds (state){
      if (!state.cartIds) {
        state.cartIds = localStorage.getItem('cartIds')
      }
      return state.cartIds
    },
    getShopId (state){
      if (!state.shopId) {
        state.shopId = localStorage.getItem('shopId')
      }
      return state.shopId
    },
    getWechatSignUrl(state){
      return state.wxSignUrl
    },
    getAppTheme(state){
      if (!state.appTheme) {
        state.appTheme = localStorage.getItem('appTheme')
      }
      return state.appTheme
    },
  },
  actions: { // 异步方法 调用方法,this.$store.dispatch("xxx")
    // 可以处理异步，通过dispatch触发，不能直接修改state，
    // 首先在组件中通过dispatch触发action，然后在action函数内部commit触发mutation，通过mutation修改state状态值
  },
  modules: { // 模块化管理
  },
  plugins: [vuexLocal.plugin]
})
